import { render, staticRenderFns } from "./emloyeeArchiveTable.vue?vue&type=template&id=66ac0232"
import script from "./emloyeeArchiveTable.vue?vue&type=script&lang=js"
export * from "./emloyeeArchiveTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports